import React from "react";

const Button = (props: any): JSX.Element => {
    const {onClick, text, ...passedProps} = props;

    return (
        <button className="w-full mt-5 mb-6 rounded bg-gray-700 py-2 px-4 font-bold text-white hover:bg-gray-600"
                onClick={onClick} {...passedProps}>
            {text}
        </button>
    );
};

export default Button;
